import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {OrderFeedback} from "../interface/order-feedback";
import {FormControl, Validators} from "@angular/forms";
import {OrderFeedbackTransmissionService} from "../../raintree/transmission/order-feedback-transmission.service";
import {RequestMapperService} from "../../request-mapper.service";

@Component({
  selector: 'fb-order-feedback-toast',
  templateUrl: './order-feedback-toast.component.html',
  styleUrls: ['./order-feedback-toast.component.scss']
})
export class OrderFeedbackToastComponent implements OnChanges {

	@Input()
	public orderId: number = 0;
	@Output()
	public onCloseEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Input()
	public orderFeedback: OrderFeedback | null = null;
	public feedback: OrderFeedback = {
		createdAt: 0,
		id: 0,
		order: {
			createdAt: 0,
			currency: "",
			dispatchedOn: 0,
			email: "",
			estimatedDeliveryFrom: 0,
			estimatedDeliveryTo: 0,
			id: 0,
			itemCount: 0,
			name: "",
			orderStatus: "",
			total: 0,
			trackingUrl: "",
		},
		question1: "We are delighted to have you as a part of Anuprerna. We appreciate your feedback. Please Rate Your Experience With Us",
		question1Answer: 0,
		question2: "",
		question2Answer: false,
		question2Negative: "",
		question2NegativeAnswer: "",
		question3Answer: "",
		question3: "Is there anything else you would like to share with us to help serve you better?",
		updatedAt: 0

	}
	public ratings: number[] = Array.from({length: 10}, (_, i) => i + 1);
	public selectedStep = 0;
	public negativeAnswer: FormControl = new FormControl("", [
		Validators.required,
		Validators.minLength(3)
	]);

	public moreFeedback: FormControl = new FormControl("", [
		Validators.required,
		Validators.minLength(3)
	]);

	constructor(
		private _feedbackAPI: OrderFeedbackTransmissionService
	) {
	}
	ngOnChanges(changes: SimpleChanges) {
		this.feedback.order.id = this.orderId;
		if(this.orderFeedback !== null) {
			this.feedback = this.orderFeedback;
			this.negativeAnswer.setValue(this.feedback.question2NegativeAnswer);
			this.moreFeedback.setValue(this.feedback.question3Answer);
			if(this.feedback.question1Answer > 0 && this.feedback.question2) {
				if(!this.feedback.question2Answer && !this.feedback.question2NegativeAnswer)
				{
					this.selectedStep = 2;
				}
				else {
					this.selectedStep = 3;
				}

			}
			else if (this.feedback.question1Answer > 0) {
				this.selectedStep = 2;
			}
			else if (this.feedback.question1Answer === 0) {
				this.selectedStep = 1;
			}
		}
		else {
			this.selectedStep = 1;
		}
	}

	public selectRating(rate: number): void {
		this.feedback.question1Answer = rate;
		if(this.orderFeedback !== null) {
			this._updateFeedback(
				RequestMapperService.UPDATE_ORDER_FEEDBACK_Q1,
				2
			)
		} else {
			this.selectedStep = 2;
		}
	}
	public selectFind(find: boolean): void {
		this.feedback.question2 = "Did you find what you were looking for?";
		this.feedback.question2Answer = find;
		if (find) {
			if(this.orderFeedback !== null) {
				this._updateFeedback(
					RequestMapperService.UPDATE_ORDER_FEEDBACK_Q2,
					3
				)
			}
			else {
				this.selectedStep = 3;
			}
		}
	}

	public submitNegativeAnswer(): void {
		if(this.negativeAnswer.valid) {
			this.feedback.question2Negative = "Tell us more about the items you were looking more";
			this.feedback.question2NegativeAnswer = this.negativeAnswer.value;
			if(this.orderFeedback !== null) {
				this._updateFeedback(
					RequestMapperService.UPDATE_ORDER_FEEDBACK_Q2,
					3
				)
			}
			else {
				this.selectedStep = 3;
			}
		}
		else {
			this.negativeAnswer.markAsDirty();
		}
	}
	public submitMoreFeedback(): void {
		if(this.moreFeedback.valid) {

			this.feedback.question3Answer = this.moreFeedback.value;
			if(this.orderFeedback !== null) {
				this._updateFeedback(
					RequestMapperService.UPDATE_ORDER_FEEDBACK_Q3,
					4
				)
			}
			else {
				this._addFeedback(false);
			}
		}
		else {
			this.moreFeedback.markAsDirty();
		}
	}
	public onClose(): void {
		if(this.orderFeedback === null)
			this._addFeedback();
		else {
			this.onCloseEmitter.emit(true);
		}
	}

	private _addFeedback(onClose: boolean = true): void {
		this._feedbackAPI.addOrderFeedback(
			this.feedback,
			() => {},
			() => {},
			() => {
			},
			() => {},
			() => {
				if(onClose) {
					this.onCloseEmitter.emit(true);
				}
				else {
					this.selectedStep = 4;
					setTimeout(() => {
						this.onCloseEmitter.emit(true)
					}, 2000)
				}
			},
		)
	}

	private _updateFeedback(url: string, step: number): void {
		this._feedbackAPI.updateOrderFeedback(
			url,
			this.feedback,
			() => {},
			() => {},
			() => {
				this.selectedStep = step;
				if (this.selectedStep === 4) {
					setTimeout(() => {
						this.onCloseEmitter.emit(true)
					}, 2000)
				}
			},
			() => {},
			() => {
			}
		)
	}

}
